import React, { useEffect, useState } from 'react';

import CollapseCustomizable from 'components/common/CollapseCustomizable';
import { RadioElement } from './common';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

function Bulk({
    numberOrderTable,
    cargoPackingIndex,
    cargoOrder,
    updateCargoOrder,
    canCheck = false,
}) {
    const [value, setValue] = useState(cargoOrder.cargo[cargoPackingIndex].packing.category);

    useEffect(() => {
        setValue(cargoOrder.cargo[cargoPackingIndex].packing.category);
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    const onCheck = () => {
        const newCargoOrder = _.cloneDeep(cargoOrder);
        newCargoOrder.cargo[cargoPackingIndex].packing.category = 'bulk';
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return (
        <div>
            <CollapseCustomizable 
                _key='bulk'
                head={
                    <RadioElement 
                        checkedValue={value}
                        disabled={!canCheck}
                        value='bulk' 
                        onCheck={() => onCheck()} 
                        label='bulk' 
                        _key='bulk' 
                    />
                }
                withCollapseIcon={false}
                headStyle={{
                    borderBottom: '1px solid #E0E0E0',
                    cursor: 'inherit',
                }}
            />
        </div>
    );
}

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        return { cargoOrder };
    },
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(Bulk));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Bulk.jsx